import { OBJECTIVE_TYPES_MAP } from 'constants/ProjectConstants';

import { useEmployeeGoalsPrivileges } from './useEmployeeGoalsPrivileges';
import useOKRConfig from './useOKRConfig';

const useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges = () => {
  const {
    hasCreateObjectivePrivilege,
    hasCreateChildKeyResultPrivilege,
    hasCreateKeyResultAtRootLevelPrivilege,
    getObjectiveLevelList,
  } = useEmployeeGoalsPrivileges();

  const { IS_KR_CASCADING_ENABLED, OBJECTIVE_TYPE } = useOKRConfig();

  const isObjectiveDisabled = OBJECTIVE_TYPE === OBJECTIVE_TYPES_MAP.DISABLED.value;

  const canCreateObjectiveAtRootLevel = !isObjectiveDisabled && hasCreateObjectivePrivilege;

  const canCreateObjectiveUnderObjective = !isObjectiveDisabled && hasCreateObjectivePrivilege;

  const canCreateObjectiveUnderKeyResult =
    !isObjectiveDisabled && IS_KR_CASCADING_ENABLED && hasCreateObjectivePrivilege;

  const canCreateKeyResultAtRootLevel = IS_KR_CASCADING_ENABLED && hasCreateKeyResultAtRootLevelPrivilege;

  const canCreateKeyResultUnderKeyResult = IS_KR_CASCADING_ENABLED && hasCreateChildKeyResultPrivilege;

  const canCreateKeyResultUnderObjective = hasCreateChildKeyResultPrivilege;

  return {
    canCreateObjectiveAtRootLevel,
    canCreateObjectiveUnderObjective,
    canCreateObjectiveUnderKeyResult,
    canCreateKeyResultAtRootLevel,
    canCreateKeyResultUnderKeyResult,
    canCreateKeyResultUnderObjective,

    getObjectiveLevelList,
  };
};

export default useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges;
